const validationExpressions = {
    validYouTubeLongUrlReg: /(?:youtube\.com\/watch[^\s]*[\?&]v=)([\w-]+)/,
    validYouTubeShortUrlReg: /(?:youtu\.be\/)([\w-]+)/,
    validVimeoUrlReg: /vimeo\.com\/(\d+)$/,
    validDailymotionUrlReg: /dailymotion\.com\/(?:video|playlist)\/([^_/]+)/,
    validFacebookUrlReg: /facebook\.com\/.+\/videos\/[A-Za-z0-9._%-]*/,
    validRepeaterItemId: /^[a-zA-Z\d-]+$/,
    validUUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
};

export default validationExpressions;


// WEBPACK FOOTER //
// ./js/modules/privates/validations/validationExpressions.es6